import * as Yup from 'yup';

// Helper function to convert multilingual data to old format for backward compatibility
export const convertToBackendFormat = (multiLangData) => {
  // Use English as primary language (fallback)
  const result = {
    title: multiLangData.title?.en || multiLangData.title || '',
    description:
      multiLangData.description?.en || multiLangData.description || '',
    translations: {
      title: multiLangData.title,
      description: multiLangData.description,
    },
  };

  // Only include policyId if it exists in the source data
  if (multiLangData.policyId) {
    result.policyId = multiLangData.policyId;
  }

  if (multiLangData.isEnable) {
    result.isEnable = multiLangData.isEnable;
  }

  return result;
};

// Helper function to convert legacy data to multilingual format
export const convertFromBackendFormat = (legacyData) => {
  // If already converted, return as-is
  if (
    legacyData.title &&
    typeof legacyData.title === 'object' &&
    legacyData.title.en !== undefined
  ) {
    return legacyData;
  }

  if (legacyData.translations) {
    return {
      id: legacyData.id, // Preserve the ID for editing
      title: legacyData.translations.title || { en: legacyData.title },
      description: legacyData.translations.description || {
        en: legacyData.description,
      },
      policyId: legacyData.policyId,
      isEnable: legacyData.isEnable || false,
    };
  }

  // Legacy format without translations
  return {
    id: legacyData.id, // Preserve the ID for editing
    title: { en: legacyData.title || '' },
    description: { en: legacyData.description || '' },
    policyId: legacyData.policyId,
    isEnable: legacyData.isEnable || false,
  };
};

export const initialValues = (form, isEdit = false) => {
  if (!form) {
    const values = {
      title: { en: '' },
      description: { en: '' },
    };

    // Only include policyId for create operations
    if (!isEdit) {
      values.policyId = '';
    }

    if (isEdit) {
      values.isEnable = false;
    }

    return values;
  }

  const convertedForm = convertFromBackendFormat(form);

  // Remove policyId for edit operations
  if (isEdit) {
    const { policyId, ...formWithoutPolicyId } = convertedForm;
    return formWithoutPolicyId;
  }

  return convertedForm;
};

// Multilingual validation schema
const multiLangStringSchema = (t) =>
  Yup.object().shape({
    en: Yup.string().required(
      t('formulary.validation.english_translation_required')
    ),
    nl: Yup.string().optional(),
  });

export const outcomeValidation = (t, isEdit = false) =>
  Yup.object().shape({
    title: multiLangStringSchema(t),
    description: multiLangStringSchema(t),
    policyId: isEdit
      ? Yup.string().optional()
      : Yup.string().required(t('formulary.validation.domain_required')),
    isEnable: Yup.boolean().optional(),
  });
